var map = {
	"./MiCONNECT_CMYK.svg": "35cb",
	"./MircomLogo.jpg": "65b4",
	"./dmpLogo.png": "defd",
	"./elabsLogo.png": "dc82",
	"./securecomLogo.png": "0150",
	"./vizibillLogo.png": "8fe1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";